const APP_INFO = {
  NAME: process.env.APP_NAME,
  VERSION: process.env.APP_VERSION,
  COMPANY: process.env.COMPANY,
  COPYRIGHT: process.env.COPYRIGHT,
  COMMIT_HASH: process.env.COMMIT_HASH
};

export default APP_INFO;
